<template>
  <div class="usage">
    <div class="container">
      <div class="header-section">
        <img src="/img/logo.png" alt="Guuu Eats" class="logo">
        <h1 class="page-title">受け取り方法</h1>
      </div>

      <div class="content-section">
        <div class="usage-item">
          <h2 class="usage-label">受け取り場所</h2>
          <p class="usage-value">
            ご注文いただいたお弁当は、<strong>群馬大学6号館</strong>で受け取れます。
          </p>
        </div>

        <div class="usage-item">
          <h2 class="usage-label">受け取り時間帯</h2>
          <p class="usage-value">
            基本的に受け取り時間帯は<strong>11:30〜12:30</strong>です。
          </p>
        </div>

        <div class="usage-item">
          <h2 class="usage-label">受け取り方法</h2>
          <p class="usage-value">
            商品に記載の受け取り番号と、画面に表示されている受け取り番号が一致するお弁当をお受け取りください。<br>
            商品が到着し、受け取ったら、下記の「受け取りました」ボタンを押してください。
          </p>
          <div class="usage-image-wrap">
            <img
              src="/img/usage-received.png"
              alt="配達完了画面の受け取りましたボタン"
              class="usage-image"
            >
          </div>
        </div>
      </div>
    </div>
    <SectionFooter />
  </div>
</template>

<script>
import SectionFooter from '@/components/sections/SectionFooter.vue';

export default {
  name: 'Usage',
  components: {
    SectionFooter,
  },
  metaInfo: {
    title: '使い方',
  },
};
</script>

<style scoped>
.usage {
  min-height: 100vh;
  background: #f8f9fa;
}

.container {
  max-width: 800px;
  margin: 0 auto 60px;
  padding: 40px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.usage > .container {
  margin-top: 40px;
}

.header-section {
  text-align: center;
  margin-bottom: 50px;
  padding-bottom: 30px;
  border-bottom: 2px solid #e9ecef;
}

.logo {
  width: 120px;
  height: auto;
  margin-bottom: 20px;
}

.page-title {
  font-size: 28px;
  font-weight: bold;
  color: #2c3e50;
  margin: 0;
  letter-spacing: 0.05em;
}

.content-section {
  padding: 0 20px;
}

.usage-item {
  margin-bottom: 35px;
  padding-bottom: 25px;
  border-bottom: 1px solid #e9ecef;
}

.usage-item:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.usage-label {
  font-size: 16px;
  font-weight: bold;
  color: #495057;
  margin-bottom: 12px;
  position: relative;
  padding-left: 20px;
}

.usage-label::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 16px;
  background: #c30d23;
  border-radius: 2px;
}

.usage-value {
  font-size: 15px;
  color: #6c757d;
  line-height: 1.8;
  margin: 0;
  padding-left: 20px;
}

.usage-image-wrap {
  margin-top: 20px;
  padding-left: 20px;
  text-align: center;
}

.usage-image {
  width: 100%;
  max-width: 320px;
  height: auto;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

@media (max-width: 768px) {
  .usage > .container {
    margin-top: 20px;
  }

  .container {
    padding: 30px 20px;
    border-radius: 0;
  }

  .header-section {
    margin-bottom: 30px;
  }

  .logo {
    width: 100px;
  }

  .page-title {
    font-size: 22px;
  }

  .content-section {
    padding: 0;
  }

  .usage-item {
    margin-bottom: 25px;
    padding-bottom: 20px;
  }

  .usage-label {
    font-size: 15px;
    margin-bottom: 10px;
  }

  .usage-value {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .container {
    padding: 25px 15px;
  }

  .page-title {
    font-size: 20px;
  }

  .usage-label {
    font-size: 14px;
  }

  .usage-value {
    font-size: 13px;
  }
}
</style>
